var map = {
	"./account.ts": 191,
	"./browseLog.ts": 192,
	"./common.ts": 193,
	"./customer.ts": 194,
	"./dictionary.ts": 195,
	"./dinerType.ts": 196,
	"./file.ts": 197,
	"./index.ts": 85,
	"./label.ts": 198,
	"./log.ts": 199,
	"./login.ts": 200,
	"./menu.ts": 201,
	"./platform.ts": 202,
	"./rankingTeam.ts": 203,
	"./role.ts": 204,
	"./sms.ts": 205,
	"./statistics.ts": 206,
	"./store.ts": 207,
	"./storeDinerType.ts": 208,
	"./tenant.ts": 209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;